export default "__VITE_ASSET__DsDv3FBN__"